<div class="color-container">
    @for (color of colorsPicker; track $index) {
        <div
            class="color-option"
            [ngClass]="{
                selected: selectedColor === color.value,
                'active-tour': isStepTourActive
            }"
            [style.background-color]="color.value" 
            (click)="!isStepTourActive && changeColor(color.value)"
        >  
        </div>
    }
</div>
